import React, {useState, useCallback} from "react";

import Joyride, {STATUS} from "react-joyride";
import Toast from "../ui/Toast";
import TourButton from "../TourButton/TourButton";
import UpdatePanel from "./UpdatePanel";
import {DocumentationLink} from "../ui/DocumentationLink";

const TOUR_LOCALE = {
    back: 'Geri',
    close: 'Kapat',
    last: 'Son',
    next: 'İleri',
    skip: "Atla"
};

const TOUR_STEPS = [
    {
        content: <h2>Çevrimdışı güncellemeler turumuza hoşgeldiniz.</h2>,
        placement: "center" as const,
        target: "body"
    },
    {
        content: <h2>Buradaki boş alana HakedişPlus uygulamasından aldığınız kodu yapıştırınız.</h2>,
        placement: "bottom" as const,
        target: "#comment"
    },
    {
        content: <h2>Buradaki butona tıklayarak çevrimdışı güncellemeleri alabilirsiniz.</h2>,
        placement: "bottom" as const,
        target: "#updateButton"
    }
];

const OfflineUpdate = () => {
    const [isTourRunning, setIsTourRunning] = useState(false);
    const [toast, setToast] = useState({isSuccess: false, message: "", showToast: false});

    const showToastMessage = useCallback((message: string, isSuccess: boolean) => {
        setToast({message, isSuccess, showToast: true});
        setTimeout(() => {
            setToast((prev) => ({...prev, showToast: false}));
        }, 3000);
    }, []);

    const handleJoyrideCallback = useCallback((data: any) => {
        const {status} = data;
        const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setIsTourRunning(false);
        }
    }, []);

    return (
        <div>
            <section className="py-14 max-w-screen-xl mx-auto">
                {isTourRunning && (
                    <Joyride
                        continuous
                        callback={handleJoyrideCallback}
                        run={isTourRunning}
                        steps={TOUR_STEPS}
                        locale={TOUR_LOCALE}
                        hideCloseButton
                        scrollToFirstStep
                        showSkipButton
                        showProgress
                    />
                )}

                <div
                    className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-900 dark:border-gray-800 dark:shadow-gray-500 transition-colors duration-300">
                    <div className="relative z-10 max-w-xl mx-auto sm:text-center">

                        <div className="space-y-3">
                            <h3 className="text-3xl font-bold">Çevrimdışı Güncelleme</h3>
                            <p className="text-gray-600 dark:text-gray-300">
                                HakedişPlus uygulamasında <b>Genel İşlemler &gt; Güncelleme Yöneticisi</b> ekranında
                                gözüken size özel güncelleme kodunu aşağıdaki bölüme yapıştırınız.
                            </p>
                        </div>

                        <UpdatePanel onShowToast={showToastMessage}/>
                        <DocumentationLink/>
                    </div>
                </div>

                <Toast
                    message={toast.message}
                    showToast={toast.showToast}
                    isSuccess={toast.isSuccess}
                />
            </section>

            <TourButton onClick={() => setIsTourRunning(true)}/>
        </div>
    );
};

export default OfflineUpdate;